import ApiService from "@/common/ApiService";
import Vue from "vue";
const apiService = new ApiService(Vue.prototype.$config.customerClubBaseAddress);

export default ({

    state: {
        customerClubData: {
        },

    },

    mutations: {
        SetCustomerClubData(state, customerClubData) {
            state.customerClubData = customerClubData;
        },

    },
    getters: {
        GetCustomerClubData(state) {
            return state.customerClubData;
        },

    },

    actions: {
        //profile 
        async getProfileByProfileId(context, id) {
            const response = await apiService.Get("Profile/ProfileQuery/getProfileByProfileId?ProfileId=" + id);
            context.commit('SetCustomerClubData', response.data);
            return response;
        },
        async updateSeenIntroduction(context, data) {
            const response = await apiService.Put("Profile/ProfileCommand/updateSeenIntroduction", data);
            return response;
        },
        // transaction
        async getCustomerTransactionsByProfileId(context, id) {
            const response = await apiService.Get("CustomerTransactionLogs/CustomerTransactionsQuery/GetCustomerTransactionsByProfileId?ProfileId=" + id);

            if (response.status == 200) {
                return response;
            }
            throw response.error;
        },
        async createTransactioIncreaseOutbound(context, data) {
            const response = await apiService.Post("transactions/transactionCommand/createTransactioIncreaseOutbound", data);

            return response;
        },

        //  end transaction
        async getCustomerScoresByProfileId(context, id) {
            const response = await apiService.Get("Transaction/TransactionQuery/GetCustomerScoresByProfileId?ProfileId=" + id);

            if (response.status == 200) {
                return response;
            }
            throw response.error;
        },
        async getCustomerProfileByBusinssId(context, id) {
            const response = await apiService.Get("Profile/ProfileQuery/getCustomerProfileByBusinssId?BusinessId=" + id);

            if (response.status == 200) {
                return response;
            }
            throw response.error;
        },
        async registerInIdentity(context, data) {
            const response = await apiService.Put("Profile/ProfileCommand/RegisterInIdentity", data);

            return response;
        },
        async checkUserPollRegistered(context, profileId) {
            const response = await apiService.Get("Poll/PollQuery/checkUserPollRegistered?profileId=" + profileId);

            if (response.status == 200) {
                return response;
            }
            throw response.error;
        },
        // poll 
        async getPollListByServiceId(context, query) {
            const response = await apiService.Get("poll/pollQuery/getPollListByServiceId?" + query);

            if (response.status == 200) {
                return response;
            }
            throw response.error;
        },
        async createUserPoll(context, data) {
            const response = await apiService.Post("Poll/PollCommand/CreateUserPoll", data);

            return response;
        },

    },

});
